import { AlertCircle } from "lucide-react";
import { formatCurrency } from "../../../../Component/AdminComponents/formatCurrency";
import BlueButton from "../../../../Component/Common/BlueButton";
import { BASE_URL } from "../../../../config/api";
import axios from "axios";
import toast from "react-hot-toast";
import { useState } from "react";

export function CommissionTable({ list, onToggle, activeTab, Navigate, setSelectedSummary}) {

  const [approveRow, setApproveRow] = useState(null);

  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
  const handleApprove = async () => {
  if (!approveRow) return;

  try {
    const res = await axios.post(
      `${BASE_URL}warranty/payout-approve`,
      {
        request_id: approveRow.payout_request.request_id,
      }
    );

    if (!res.data?.status) {
      toast.error(res.data?.message || "Approval failed");
      return;
    }

    toast.success("Payout approved successfully");

    setApproveRow(null);

    // 🔥 refresh
    window.location.reload();

  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  }
};

  if (!list.length) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-slate-400">
        <AlertCircle size={28} className="mb-2 opacity-40" />
        <p className="text-sm font-semibold">No records found</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-xs">
        <thead>
          <tr className="text-left" style={{ borderBottom: "1px solid #F1F5F9" }}>
            {[
              "Unbilled ID",
              "Entity",
              "Role / Period",
              "Amounts (₹)",
              ...(activeTab === "billed" ? ["Bank / Txn", "Date"] : []),
              "Status",
              "Action",
            ].map((h) => (
              <th key={h} className="pb-3 pr-4 font-black uppercase tracking-widest" style={{ fontSize: 10, color: "#94A3B8" }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {list.map((p) => {
            const showApprove =
              authUser?.role === 1 &&
              p.payout_request &&
              p.payout_request.status === "verified" &&
              p.payout_request.request_id;

            return (
              <tr
                key={p.id}
                className="group hover:bg-slate-50/60 transition-colors"
                style={{ borderBottom: "1px solid #F8FAFC" }}
              >
                <td className="py-3 pr-4">
                  <span className="font-bold text-slate-700">{p.id}</span>
                </td>

                <td className="py-3 pr-4">
                  <p className="font-bold text-slate-800 whitespace-nowrap">{p.entityName}</p>
                  <p className="text-[10px] text-slate-400 mt-0.5">{p.forType}</p>
                </td>

                <td className="py-3 pr-4">
                  <p className="text-slate-700 font-semibold whitespace-nowrap">{p.forType}</p>
                  <p className="text-[10px] text-slate-400 mt-0.5">
                    {p.date} to {p.end_date}
                  </p>
                </td>

                <td className="py-3 pr-4">
                  <p className="font-semibold text-slate-700">
                    ₹{formatCurrency(p.commissionAmount)}
                  </p>
                </td>

                {activeTab === "billed" && (
                  <td className="py-3 pr-4">
                    <p className="font-semibold text-slate-700 whitespace-nowrap">
                      {p.bankName} · ****{p.accountLast4}
                    </p>
                    <p className="text-[10px] text-slate-400 mt-0.5">
                      Txn: {p.txnId}
                    </p>
                  </td>
                )}

                {activeTab === "billed" && (
                  <td className="py-3 pr-4">
                    <p className="text-slate-600 whitespace-nowrap">{p.date}</p>
                  </td>
                )}

                {/* STATUS + APPROVE */}
                <td className="py-3 pr-4 space-y-1">
                  

                  <div>
                    <span
                      className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-bold"
                      style={{
                        background: p.transferred ? "#ECFDF5" : "#FFFBEB",
                        color: p.transferred ? "#059669" : "#D97706",
                        border: `1px solid ${
                          p.transferred ? "#A7F3D0" : "#FDE68A"
                        }`,
                      }}
                    >
                      <span
                        className="w-1.5 h-1.5 rounded-full"
                        style={{
                          background: p.transferred ? "#10B981" : "#F59E0B",
                        }}
                      />
                      {p.transferred ? "Transferred" : "Pending"}
                    </span>
                  </div>
                </td>

                {/* ACTIONS */}
                <td className="py-3">
                  <div className="flex gap-2">

                    {activeTab !== "current" && showApprove && (
                        <button
                          onClick={() => setApproveRow(p)}
                          className="px-3 py-1 rounded-lg text-xs font-bold bg-green-600 text-white hover:bg-green-700"
                        >
                          Approve
                        </button>
                      )}

                    {activeTab === "billed" && (
                      
                      <button
                        onClick={() => onToggle(p.id)}
                        className="px-3 py-1.5 rounded-xl text-[11px] font-bold transition-all hover:scale-105 active:scale-95 whitespace-nowrap"
                        style={{
                          background: p.transferred ? "#FEF2F2" : "#EFF6FF",
                          color: p.transferred ? "#EF4444" : "#2563EB",
                          border: `1px solid ${
                            p.transferred ? "#FECACA" : "#BFDBFE"
                          }`,
                        }}
                      >
                        {p.transferred ? "Mark Pending" : "Mark Transferred"}
                      </button>
                    )}

                    {activeTab === "unbilled" && (
                      <button
                        onClick={() => setSelectedSummary(p)}
                        className="px-3 py-1.5 rounded-xl text-[11px] font-bold bg-amber-50 text-amber-600 border border-amber-200 hover:bg-amber-100"
                      >
                        Summary
                      </button>
                    )}

                    <BlueButton
                      onClick={() =>
                        Navigate(`/commission-details`, {
                          state: { row: p },
                        })
                      }
                    >
                      View
                    </BlueButton>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {approveRow && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ background: "rgba(0,0,0,0.4)" }}
          onClick={() => setApproveRow(null)}
        >
          <div
            className="bg-white rounded-2xl w-full max-w-sm p-6 shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-bold text-slate-800 mb-2">
              Approve Payout
            </h3>

            <p className="text-sm text-slate-500 mb-4">
              Are you sure you want to approve this payout?
            </p>

            <div className="bg-slate-50 p-3 rounded-lg mb-4 text-xs">
              <p><strong>For Month:</strong> {approveRow.date} to {approveRow.end_date} </p>
              <p><strong>Amount:</strong> ₹{formatCurrency(approveRow.commissionAmount)}</p>
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setApproveRow(null)}
                className="px-4 py-2 text-sm rounded-lg border border-slate-300 text-slate-600"
              >
                Cancel
              </button>

              <button
                onClick={handleApprove}
                className="px-4 py-2 text-sm rounded-lg bg-green-600 text-white font-bold hover:bg-green-700"
              >
                Confirm Approve
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}